export default {"src":"/_next/static/media/lock_circle.c73a6ee0.svg","height":54,"width":54};